module.exports = __webpack_public_path__ + "static/img/duofanghuiyi2.b3c690b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/duofanghuiyi2.png
// module id = HIAz
// module chunks = 24